export default function setFocus(element) {
  element.focus();
}
